/**
 * video-button custom element
 * - Pause/Play videos
 *
 * {%- render 'video',
 *   button: true,
 *   video: video,
 * -%}
 *
*/
(() => {
  class VideoButton extends HTMLElement {
    constructor() {
      super();
      this.settings();
      this.listeners();
    }

    settings() {
      this.buttonEl = this.querySelector('[data-video-button]');
      this.videoId = this.buttonEl.dataset.videoButton;
      this.videoEls = document.querySelectorAll(`video[id="${this.videoId}"]`) || this.closest('*').querySelectorAll('video');
      this.isLink = this.videoEl && this.videoEl.closest('a') !== null;
      this.hasControls = this.hasAttribute('data-controls');
      this.loadOnPlay = this.hasAttribute('data-load-video-on-play');
      this.sectionEl = this.closest('.shopify-section');
      if (this.loadOnPlay) this.loaded = false;
    }

    listeners() {
      if (!this.videoEls.length) return;

      this.buttonEl.addEventListener('click', e => {
        e.preventDefault();
        this.videoEls.forEach(video => {
          this.toggle(video);
        });
      });

      this.videoEls.forEach(video => {
        video.addEventListener('pause', () => {
          this.setState(video, false);
          if (this.hasControls) video.removeAttribute('controls');
        });

        video.addEventListener('play', () => {
          this.setState(video, true);

          this.sectionEl?.querySelectorAll(`video:not(#${this.videoId})`).forEach(el => el.pause());

          if (this.hasControls) video.setAttribute('controls', '');
        });

        video.addEventListener('click', () => {
          if (!video.controls) this.toggle(video);
        });
      });

      if (this.hasAttribute('data-sync-initial-state')) {
        this.videoEls.forEach(video => this.setState(video, !video.paused));
      }

      if (this.isLink) {
        this.buttonEl.addEventListener('keyup', e => {
          if (e.key !== 'Enter') return;
          e.preventDefault();

          this.videoEls.forEach(video => {
            // this.toggle(video);
          });
        });

        return;
      }
    }

    setState(video, isPlaying) {
      this.buttonEl.ariaPressed = isPlaying;
      this.classList.toggle('video--playing', isPlaying);
      this.classList.toggle('video--paused', !isPlaying);
      video.classList.toggle('video--playing', isPlaying);
      video.classList.toggle('video--paused', !isPlaying);
    }

    toggle(video) {
      if (this.loadOnPlay && !this.loaded) {
        video.src = video.dataset.loadVideoOnPlaySrc;
        this.loaded = true;
      }

      video[video.paused ? 'play' : 'pause']();
    }
  }

  if (!customElements.get('video-button')) {
    customElements.define('video-button', VideoButton);
  }
})();
